"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ServiceHttpResponseError = _interopRequireDefault(require("../util/ServiceHttpResponseError"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BaseClient =
/*#__PURE__*/
function () {
  function BaseClient(getAccessToken, endpointUrl) {
    (0, _classCallCheck2["default"])(this, BaseClient);
    this.getAccessToken = getAccessToken;
    this.endpointUrl = endpointUrl;
  }

  (0, _createClass2["default"])(BaseClient, [{
    key: "fetchWithAuth",
    value: function () {
      var _fetchWithAuth = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(_ref) {
        var endpointUrl, _ref$method, method, route, body, _ref$additionalHeader, additionalHeaders, _ref$giveSimpleRespon, giveSimpleResponse, options, fullUrl, rawResponse, parsedResponse;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpointUrl = _ref.endpointUrl, _ref$method = _ref.method, method = _ref$method === void 0 ? 'GET' : _ref$method, route = _ref.route, body = _ref.body, _ref$additionalHeader = _ref.additionalHeaders, additionalHeaders = _ref$additionalHeader === void 0 ? {} : _ref$additionalHeader, _ref$giveSimpleRespon = _ref.giveSimpleResponse, giveSimpleResponse = _ref$giveSimpleRespon === void 0 ? true : _ref$giveSimpleRespon;
                options = this.buildOptions(method, body, additionalHeaders);
                fullUrl = route ? "".concat(endpointUrl, "/").concat(route) : endpointUrl;
                _context.next = 5;
                return fetch(fullUrl, options);

              case 5:
                rawResponse = _context.sent;
                _context.next = 8;
                return this.checkResponse(rawResponse, "".concat(method, " ").concat(fullUrl), giveSimpleResponse);

              case 8:
                parsedResponse = _context.sent;
                return _context.abrupt("return", parsedResponse);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchWithAuth(_x) {
        return _fetchWithAuth.apply(this, arguments);
      }

      return fetchWithAuth;
    }()
  }, {
    key: "buildOptions",
    value: function buildOptions(method, body, additionalHeaders) {
      var headers = new Headers(_objectSpread({
        Accept: additionalHeaders.accept ? additionalHeaders.accept : 'application/json',
        Authorization: "Bearer ".concat(this.getAccessToken())
      }, additionalHeaders));
      var requestBody = body;

      if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
        headers.append('Content-Type', 'application/json');
      }

      if (body && typeof body !== 'string') {
        requestBody = JSON.stringify(body);
      }

      return {
        body: requestBody,
        cache: 'default',
        headers: headers,
        method: method,
        mode: 'cors'
      };
    }
  }, {
    key: "checkResponse",
    value: function () {
      var _checkResponse = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(res, serviceComment, isSimpleResponse) {
        var body, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!res.ok) {
                  _context2.next = 7;
                  break;
                }

                if (!(res.status === 204)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", isSimpleResponse ? null : {
                  response: res
                });

              case 3:
                _context2.next = 5;
                return res.json();

              case 5:
                body = _context2.sent;
                return _context2.abrupt("return", isSimpleResponse ? body : {
                  body: body,
                  response: res
                });

              case 7:
                _context2.next = 9;
                return /application\/json/.test(res.headers.get('content-type')) ? res.json() : res.text();

              case 9:
                body = _context2.sent;
                response = {
                  body: body,
                  ok: res.ok,
                  status: res.status,
                  statusText: res.statusText
                };
                throw new _ServiceHttpResponseError["default"]("Error fetching ".concat(serviceComment), response);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function checkResponse(_x2, _x3, _x4) {
        return _checkResponse.apply(this, arguments);
      }

      return checkResponse;
    }()
  }]);
  return BaseClient;
}();

exports["default"] = BaseClient;